<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'GetAuth',
  created () {
    const url = new URL(window.location.href)
    const params = url.searchParams
    if (params) {
      this.$router.push({
        name: 'thirparty',
        params: {
          id: 'instagramfeed'
        },
        meta: {
          code: params.code
        }
      })
    }
  }
}
</script>
